/**
 * `:root` CSS string — inject once (e.g. app entry): `import { formTokensCss } from '@kioskgaming/ui'` then add to `<style>` or global bundle.
 * Defines spacing, radius, form border/focus colors used in `Input`, `fieldStyles`, table filters, etc.
 */
export const formTokensCss = `
:root{
  --space-xs: 4px;
  --space-sm: 8px;
  --space-md: 12px;
  --space-lg: 16px;
  --space-xl: 24px;
  --space-2xl: 32px;
  --space-3xl: 48px;

  --radius-sm: 6px;
  --radius-md: 8px;
  --radius-lg: 12px;

  --text-meta: 11px;
  --text-hint: 12px;
  --text-description: 13px;
  --text-body: 14px;
  --text-section: 16px;

  --stroke-default: 0.5px;
  --stroke-normal: 1px;
  --stroke-active: 1.5px;

  --field-height-sm: 32px;
  --field-height-md: 40px;
  --field-height-lg: 48px;
  --field-padding-x: 12px;

  --form-row-gap: 16px;
  --form-card-padding: 24px;
  --form-field-gap: 6px;
  --form-divider: var(--stroke-default);

  --form-fg: #0b1220;
  --form-fg-muted: rgba(11, 18, 32, 0.66);
  --form-bg: #ffffff;
  --form-bg-muted: rgba(11, 18, 32, 0.04);
  --form-bg-disabled: rgba(11, 18, 32, 0.06);

  --form-border: rgba(11, 18, 32, 0.22);
  --form-border-hover: rgba(11, 18, 32, 0.36);
  --form-border-focus: #2563eb;
  --form-border-error: #dc2626;
  --form-border-success: #16a34a;

  --form-ring-focus: rgba(37, 99, 235, 0.12);
  --form-ring-error: rgba(220, 38, 38, 0.12);
  --form-ring-success: rgba(22, 163, 74, 0.12);

  --form-placeholder: rgba(11, 18, 32, 0.38);
  --form-required: #dc2626;
}
`;
export const formTokens = { css: formTokensCss };
